import React from 'react';
import { LayoutCard } from './list-organizations-management.styles.';
import { useOrganizationsListSharedQuery } from '@entities/organization/libs/hooks/use-organizations-list-shared-query/use-organizations-list-shared-query';
import { CardOrganization } from '@entities/organization/ui/card-organization/card-organization';
import { LockOrganization } from '@features/organization/lock-organization/ui/lock-organization';
import { ListOrganizationsManagementProps } from './types';
import { PaginationLayout } from '@shared/ui/pagination-layout/pagination-layout';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { EditOrganization } from '@features/organization/edit-organization/ui/edit-organization';

export const ListOrganizationsManagement: React.FC<ListOrganizationsManagementProps> = ({
    organizationsListParameters,
    setOrganizationsListParameters,
}) => {
    const [, getOrganizationsListResult, resetOrganizations] =
        useOrganizationsListSharedQuery(organizationsListParameters);
    const isLoading =
        getOrganizationsListResult.isLoading ||
        getOrganizationsListResult.isFetching ||
        getOrganizationsListResult.isUninitialized;

    const handleSuccess = () => {
        resetOrganizations();
        setOrganizationsListParameters({ ...organizationsListParameters });
    };

    return (
        <PaginationLayout
            listLength={getOrganizationsListResult.data?.total || 0}
            isLoading={isLoading}
            parameters={organizationsListParameters}
            setParameters={setOrganizationsListParameters}>
            <LayoutCard>
                <NetworkStateNew
                    isLoading={isLoading}
                    isError={getOrganizationsListResult.isError}
                    isInitialized={Boolean(getOrganizationsListResult.data)}
                    isFiltered={Boolean(getOrganizationsListResult.data?.search)}
                    hasData={Boolean(getOrganizationsListResult.data?.items.length)}
                    errorProps={{
                        title: 'Ошибка загрузки организаций',
                        description: getQueryError(getOrganizationsListResult)?.message,
                    }}
                    emptyProps={{
                        title: 'Организации отсутствуют',
                    }}
                    emptyFilteredProps={{
                        title: 'Организации не найдены',
                    }}
                    updateLoaderProps={{
                        style: { left: 20, right: 20 },
                    }}>
                    {getOrganizationsListResult.data?.items.map((organization) => (
                        <CardOrganization key={organization.id} organization={organization}>
                            <EditOrganization organization={organization} onSuccess={handleSuccess} />
                            <LockOrganization organization={organization} onSuccess={handleSuccess} />
                        </CardOrganization>
                    ))}
                </NetworkStateNew>
            </LayoutCard>
        </PaginationLayout>
    );
};
